import { object, number, string, array } from '@gogame/schemas';

import {
  FILTER_STATUSES,
  FILTER_PARTNER_COMPANIES,
  FILTER_CUSTOMER_COMPANIES,
  FILTER_NETWORKS,
  FILTER_INVOICE_LEVELS,
  FILTER_CURRENCIES,
  FILTER_EXPENSE_TYPES,
  FILTER_OWNERS,
  FILTER_CREATORS,
  STATUS_DRAFT,
  STATUS_ACTIVE,
  STATUS_IN_TEST,
} from 'scenes/BusinessPartners/constants';

export const EMPTY_FILTERS = {
  [FILTER_STATUSES]: [STATUS_DRAFT, STATUS_ACTIVE, STATUS_IN_TEST],
};

export const filtersSchema = object({
  [FILTER_STATUSES]: array(number()),
  [FILTER_PARTNER_COMPANIES]: array(number()),
  [FILTER_CUSTOMER_COMPANIES]: array(number()),
  [FILTER_NETWORKS]: array(number()),
  [FILTER_INVOICE_LEVELS]: array(number()),
  [FILTER_CURRENCIES]: array(string()),
  [FILTER_EXPENSE_TYPES]: array(number()),
  [FILTER_OWNERS]: array(number()),
  [FILTER_CREATORS]: array(number()),
}).default(EMPTY_FILTERS);
